import { makeStyles } from "@material-ui/core";
import { theme } from "config/theme";
import styled from "styled-components";

export const NavigationWrapper = styled.div`
  text-align: right;
  width: calc(100% + 0px);
  padding: 6px 3px;
  display: flex;
  ${theme.breakpoints.down("xs")} {
    padding: 10px 18px;
    text-align: right;
    width: calc(100% + 17px);
    margin-top: -31px;
  }

  div {
    flex: 1;
  }

  .nextButton {
    float: inline-end;
    margin-left: 50px;
    ${theme.breakpoints.down("xs")} {
      width: 150px;
      margin-top: -1px;
    }
  }

  .actions {
    justifycontent: space-between;
    ${theme.breakpoints.down("xs")} {
      display: initial;
      margin-top: -20px;
      margin-right: 21px;
    }
  }

  div.extra {
    align-items: center;
    display: flex;
  }

  button {
    width: 155px;
    ${theme.breakpoints.down("xs")} {
    }
  }
  .previous {
    background: #cfecf9;
    border: 1.5px solid #399ebf;
    margin-right: -20px;
    ${theme.breakpoints.down("xs")} {
      margin-right: 160px;
      margin-bottom: -53px;
      width: 150px;
    }
  }
`;

export const useRowStyles = makeStyles({
  root: {
    background: "#e2f4fb",
    height: "44px",
    borderRadius: "11px",
    padding: "10px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    position: "relative",
    marginTop: "0px",
  },
  collapseStop: {
    padding: "10px 0",
  },
  li: {
    fontSize: 10,
  },
  collapse: {
    background: "#399ebf",
    borderRadius: "8px",
    color: "#fff !important",
    height: "24px",
    width: "24px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",

    "& .MuiIconButton-label": {
      color: "#fff",
    },
  },
  axes: {
    fontSize: "14px",
    color: "#399ebf",
    fontFamily: "Montserrat",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    textAlign: "left",
    display: "flex",
    alignItems: "center",
  },
  divStyled: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    color: "#399ebf",
    fontWeight: "bold",
    cursor: "pointer",
  },
  divNumber: {
    color: "#fff",
    borderRadius: "8px",
    backgroundColor: "#399ebf",
    padding: "1px 5px",
    marginLeft: "5px",
    fontSize: "11px",
    border: "0.7px solid #fff",
  },
  vehicleInfo: {
    display: "flex",
    marginLeft: "auto",
    marginRight: "10px",
  },
  icon: {
    padding: "5px",
    backgroundColor: "#fff",
    border: "0.7px solid #399ebf",
    borderRadius: "5px",
  },
  divContainer: {
    border: "1px solid #e2f4fb",
    borderRadius: "13px",
    height: "auto",
    marginBottom: "10px",
  },
  div1: {
    height: "10px",
    marginLeft: "8px",
    borderLeft: "1px solid",
  },
  div2: {
    height: "7px",
    border: "2px solid #399ebf",
    width: "7px",
    borderRadius: "5px",
    marginLeft: "4.5px",
  },
  div3: {
    height: "10px",
    marginLeft: "8px",
    borderLeft: "1px solid",
  },
  ulDopdownStyled: {
    listStyle: "none",
    display: "contents",
    position: "relative",
    "& >li": {
      padding: "6px",
      borderBottom: "solid 1px",
      borderBottomColor: "#7878781c",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },
  },
  divContainerUl: {
    backgroundColor: "#fff",
    borderRadius: "2px",
    marginTop: "5rem",
    boxShadow: "0 1rem 2rem rgba(0, 0, 0, 0.1)",
    textAlign: "center",
  },
  divContainerDropdown: {
    display: "flex",
    flexDirection: "column",
    color: "#787878",
    position: "absolute",
    zIndex: 1,
  },
  collapseStyled: {
    marginTop: "10px",
    marginBottom: "5px",
  },
  details: {
    marginBottom: "-20px",
    color: "#399ebf",
    fontSize: "14px",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    [theme.breakpoints.down("xs")]: {},
  },

  hr: {
    position: "relative",
    top: "-15px",
    width: "80%",
    right: "-44px",
    height: "2px",
    border: "none",
    backgroundColor: "rgba(57, 158, 191, 0.2)",
    [theme.breakpoints.down("xs")]: {
      width: "67%",
      right: "-47px",
    },
  },
});
